import { marketCountryIdFormat } from "@redotech/redo-xborder-outbound-id";
import {
  marketCountryCode,
  marketSettingsInputFields,
  refineMarketInclusion,
} from "@redotech/redo-xborder-outbound-sdk/schema/market-definition";
import * as z from "zod";
import { marketWithCountriesOutput } from "./market";

const conflictResolution = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("archive_existing"),
    conflictMarketId: z.string(),
  }),
  z.object({ kind: z.literal("remove_region"), conflictMarketId: z.string() }),
  z.object({ kind: z.literal("take_over"), conflictMarketId: z.string() }),
]);

const countryInput = z.object({
  id: marketCountryIdFormat.schema.optional(),
  destinationCountryCode: marketCountryCode,
  resolution: conflictResolution.optional(),
});

// Country rows missing from the input list are soft-deleted.
export const upsertMarket = {
  name: "upsertMarket" as const,
  input: z
    .object({
      ...marketSettingsInputFields,
      artifactId: z.string().nullable().optional(),
      countries: z.array(countryInput),
    })
    .superRefine(refineMarketInclusion),
  output: marketWithCountriesOutput.extend({
    variantsMissingHsCode: z.number().optional(),
  }),
};
